import { useGetMemberSubscriptionOverviewQuery } from '@/types/generated/graphql';
import { AccessControlledWrapper } from '@components/plan-role-access-control-wrapper/access-controlled-wrapper';
import { useMembers } from '@modules/settings/members/use-members';
import { InviteMemberModal } from '@modules/settings/subscription/components/modal-invite-member';
import { useInviteMember } from '@modules/settings/subscription/hooks/use-invite-member';
import { PLAN_MAPS } from '@shared/constants/plans';
import { ROLE_MAPS } from '@shared/constants/roles';
import { capitalize } from '@shared/utils/capitalize';
import { hasPlanAccess } from '@shared/utils/roles/has-plan-access.helper';
import { hasRoleAccess } from '@shared/utils/roles/has-role-access.helper';
import { Button } from 'antd';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { RiAddLine } from 'react-icons/ri';

type Props = { isOverlay?: boolean };

export function AddMember({ isOverlay }: Props) {
  const memberSubscriptionOverview = useGetMemberSubscriptionOverviewQuery();
  const isStandardPlan =
    memberSubscriptionOverview?.data?.getMemberSubscriptionOverview?.data?.plan?.label === 'Standard Plan';
  const inviteController = useInviteMember();
  const { membersCount } = useMembers();
  const [canInviteMember] = hasRoleAccess([ROLE_MAPS.SETTINGS_MEMBERS_INVITE_MEMBERS]);
  const [hasMemberInvitePlanAccess] = hasPlanAccess(PLAN_MAPS.SETTINGS_MEMBERS_INVITE_MEMBERS);
  const { t } = useTranslation();
  const hasInviteMemberAccessByPlan = hasMemberInvitePlanAccess && (!isStandardPlan || membersCount < 10);

  return (
    <div
      className={clsx(isOverlay ? 'h-9' : 'h-5.5')}
      onKeyDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <AccessControlledWrapper
        hasRoleAccess={canInviteMember}
        hasPlanAccess={hasInviteMemberAccessByPlan}
        tooltip={capitalize(t('invite_member_one'))}
      >
        <Button
          type="text"
          size="small"
          disabled={!canInviteMember || !hasInviteMemberAccessByPlan}
          className={clsx(
            isOverlay ? 'size-9! rounded-full!' : 'p-0! min-w-0! h-auto! leading-none! text-text-600 -translate-y-1!'
          )}
          onClick={inviteController.inviteModal.handleOpen}
        >
          <RiAddLine className="size-5" />
        </Button>
      </AccessControlledWrapper>
      <InviteMemberModal inviteController={inviteController} />
    </div>
  );
}
